import React from 'react';
import PropTypes from 'prop-types';
import './WorkflowTask.scss'
import WorkflowTask from './WorkflowTask';

const SkeletonTask = (props) => {
    return (
        <WorkflowTask status={null} taskId={props.taskId}>
            <div className='bob'>
            </div>
        </WorkflowTask>
    );
}

SkeletonTask.propTypes = {
    taskId: PropTypes.string.isRequired
}

export default SkeletonTask